<template>
<div style="background-color: #fff;margin:24px">
	<top-title
      name="生日权益配置"
      pageName="品牌定制-生日权益配置"
      style=" min-width: 1066px"
  ></top-title>
	<div style="min-height: 720px;padding: 0 20px 20px 0;">
		<el-form
			:model="formData"
			:disabled="isLook"
			ref="formData"
			class="backgroundForm"
			label-width="200px"
		>
			<el-form-item label="活动链接："  v-if="formData.venderId">
				<div class="link">
					<el-popover placement="top-start" width="500" trigger="hover">
							<p style="margin: 20px">
								请用手机京东扫描下面二维码查看您店铺的活动详情
							</p>
							<qrcode-vue
								class="qrcode"
								:id="'qrcode' + formData.id"
								:ref="'qrcode' + formData.id"
								:size="qrcodeVue.size"
								:value="formData.idUrl"
								:logo="qrcodeVue.logo"
								:bgColor="qrcodeVue.bgColor"
								:fgColor="qrcodeVue.fgColor"
								style="margin-left: 80px"
							></qrcode-vue>
							<div>
								<p style="margin: 20px">
									链接地址：(手机京东店铺中活动详情链接地址)
								</p>
								<el-input v-model="formData.idUrl" style="margin: 0 20px; width: 220px"></el-input
								><el-button type="primary" v-clipboard:copy="formData.idUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
									>复制</el-button
								>
								<el-button type="primary" @click="handleSrcImg(formData.id)">下载</el-button>
							</div>
							<img src="../../assets/images/integralCenter/list_code.svg" alt="活动二维码" class="code" slot="reference" />
					</el-popover>
					<div style="margin:0 10px;">{{ formData.idUrl }}</div>
				</div>
			</el-form-item>

			<el-form-item label="活动状态：" >
				<el-radio-group v-model="formData.status">
					<el-radio :label="1">开启</el-radio>
					<el-radio :label="0">关闭</el-radio>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="活动关闭说明文案：" required>
				<el-input
					type="textarea"
					placeholder="请填写"
					v-model="formData.activityCloseDescription"
					maxlength="500"
					style="max-width: 543px;"
					show-word-limit
					:rows="5"
				></el-input>
			</el-form-item>

			<el-form-item label="活动规则说明:" required>
				<div></div>
				<el-upload
					ref="upload"
					action="#"
					list-type="picture-card"
					:on-change="(file, fileList) => {handleChange(file, fileList, 'ruleDetail')}"
					:on-remove="(file, fileList) => {handleRemove(file, fileList, 'ruleDetail')}"
					:http-request="httpRequest"
					:file-list="fileList"
					:limit="1"
					:before-upload="beforeUpload"
					:class="fileList.length == 1?'hide_box':''"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<span style="color: red; font-size: 14px">建议尺寸：303 px*360px，图片大小不能超过300kb，类型：JPG、PNG</span>
			</el-form-item>

			<el-form-item label="生日权益说明图:">
				<el-table
					:header-cell-style="{
						'text-align': 'center',
						'border-bottom': '2px solid #EBEEF5',
						background: '#FAFAFA',
					}"
					:cell-style="{ 'text-align': 'center', overflow: 'visible' }"
					:data="benefitDescriptionConfigList"
					border
					style="width: 1100px;overflow: visible;"
				>
					<el-table-column label="生日权益说明图" width="410">
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;">
							<el-upload
								ref="upload2"
								action="#"
								class="avatar-uploader"
								list-type="picture-card"
								:http-request="httpRequest"
								:on-change="(file, fileList) => {handleChange2(file, fileList,scope.$index)}"
								:on-remove="(file, fileList) => {handleRemove2(file, fileList,scope.$index)}"
								:before-upload="beforeUpload"
								v-loading="scope.row.imgLoading"
								:class="scope.row.ishaveUrl?'hide_box':''"
								:file-list="fileList2"
							>

								<img v-if="scope.row.birthdayBenefitDescription" :src="scope.row.birthdayBenefitDescription" class="avatar">
								<i class="el-icon-plus"></i>
							</el-upload>

							<div style="color: red; font-size: 14px;">建议尺寸：303 px*360px，图片大小不能超过300kb，类型：JPG、PNG</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="生效时间段" width="480">
						<template slot-scope="scope">
							<div class="my_select_time" v-if="scope.row.category != 0">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="scope.row.startEnableTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange(scope.$index)"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="scope.row.endEnableTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange(scope.$index)"
                  :picker-options="pickerOptionsValueEnd"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTime(scope.$index)"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<span
								v-if="scope.row.category != 0"
								class="s"
								style="color:#7B61FF;cursor: pointer;"
								@click="itemDel(scope.$index)"
								>删除</span
							>
							<span v-else>-</span>
						</template>
					</el-table-column>
				</el-table>
				<div
					@click="addBenefit"
					class="add_btn1"
					style="width: 125px;"
				>
					添加权益图
				</div>
			</el-form-item>

			<el-form-item label="等级生日权益:">
				<span>设置多张优惠券，则会员满足：①等级条件；②生日当月发放条件 时可全部获得；③无论设置多少张优惠券，只要领取了某个等级下的任意一张优惠券，会员升级或者降级都不可领取任何优惠券。</span>
				<div class="newCard">
					<el-tabs v-model="editableTabsValue" type="card" class="zindexBox">
						<el-tab-pane
							:key="item.name + index"
							v-for="(item, index) in editableTabs"
							:label="item.title"
							:name="item.name"
						>
						<div class="prize_box">
								<el-table
									:header-cell-style="{
										'text-align': 'center',
										'border-bottom': '2px solid #EBEEF5',
										background: '#FAFAFA',
									}"
									:cell-style="{ 'text-align': 'center', overflow: 'visible' }"
									:data="item.content"
									border
									style="width:1400px;overflow: visible;"
								>
									<el-table-column prop="date" label="序号" width="110">
										<template slot-scope="scope">
											<span>{{ scope.$index + 1 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="奖品类型">
										<template slot-scope="scope">
											<div>
												<span style="color:#7F85E9;cursor: pointer;" @click="selectCoupon(scope.$index)">{{
													scope.row.title ? '优惠券' : "选择优惠券"
												}}</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="title" width="180" label="优惠券名称">
									</el-table-column>
									<el-table-column width="145" label="奖品总份数">
										<template slot-scope="scope">
											<el-input
												v-model="scope.row.totalAmount"
												placeholder="请输入"
												@input="scope.row.totalAmount = getNumberData(1, $event, 0, 1)"
											></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="生效时间" width="480">
										<template slot-scope="scope">
											<div class="my_select_time">
												<el-date-picker
													prefix-icon="no_icon"
													v-model="scope.row.startEnableTime"
													type="datetime"
													placeholder="开始日期"
													size="small"
													format="yyyy-MM-dd HH:mm:ss"
													value-format="yyyy-MM-dd HH:mm:ss"
													style="width: 185px; font-size: 12px"
													class="time1"
													@change="activityTimeChange2(scope.$index)"
													:picker-options="pickerOptionsValue"
													:clearable="false"
												>
												</el-date-picker>
												<div class="time_to_text">至</div>
												<el-date-picker
													prefix-icon="no_icon"
													v-model="scope.row.endEnableTime"
													type="datetime"
													placeholder="结束日期"
													size="small"
													format="yyyy-MM-dd HH:mm:ss"
													value-format="yyyy-MM-dd HH:mm:ss"
													style="width: 200px; font-size: 12px"
													class="time2"
													@change="activityTimeChange2(scope.$index)"
													:picker-options="pickerOptionsValueEnd"
													:clearable="false"
												>
												</el-date-picker>
												<i class="el-icon-circle-close date_icon1" @click="clearTime2(scope.$index)"></i>
												<img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
											</div>
										</template>
									</el-table-column>
									<el-table-column width="100" label="操作">
											<template  slot-scope="scope">
												<span v-if="scope.row.remanentAmount == scope.row.totalAmount" @click="itemDelPrize(scope.$index)" style="cursor: pointer;color: #7B61FF;">删除</span>
												<span v-else>-</span>
											</template>
									</el-table-column>
								</el-table>
								<div
									@click="addPrizeRule"
									class="add_btn1"
									style="width: 125px;"
								>
									添加奖项
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</el-form-item>
			
		</el-form>
		<div class="create_bottom" >
      <el-button
        class="saveBtn"
        size="medium"
        @click="save()"
        >确定</el-button>
		</div>
	</div>
	 <!-- 选择优惠券 -->
	 <selectPrize v-model="dialogPrize" @closePrize="closePrize"></selectPrize>
</div>
</template>

<script>
import topTitle from "../../components/top-title";
// import selectPrize from "../integralCenter/select_prize.vue";
import selectPrize from "./dialog/select_prize.vue";
import qrcodeVue from "qrcode-vue";
import {uploadpic,getBenefitConfig,postBenefitConfig,getRuleInfo } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {
	topTitle,
	qrcodeVue,
	selectPrize
},
props:{},
data() {
return {
	isLook:false,
	loading:false,
	qrcodeVue: {
		size: 260,
		bgColor: "#fff",
		fgColor: "#000",
		value: "https://www.baidu.com/", //二维码地址
		logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
	},
	formData:{
		id:123,
		idUrl : "pages/integralStore/exchange/exchange.html%3fitem%3d",
		status:0,
		activityCloseDescription:'',//活动关闭说明文案
		ruleDetail:'',//活动规则说明图
	},
	//生日权益说明图
	benefitDescriptionConfigList:[{
		birthdayBenefitDescription:'',
		startEnableTime:'',
		endEnableTime:'',
		imgLoading:false,
		ishaveUrl:false,
		category:1,
	}],
	fileList: [],
	fileList2:[],
	imgLoading:false,
	pickerOptionsValue: {
		// disabledDate: (time) => {
		// 	return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.benefitDescriptionConfigList.endEnableTime).valueOf()-24*60*60*1000;
		// },
	},
	pickerOptionsValueEnd: {
		// selectableRange: "12:59:59 - 23:59:59",
		// 	disabledDate: (time) => {
		// 		return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.benefitDescriptionConfigList.startEnableTime).valueOf();
		// 	},
	},
	editableTabsValue: '1',
	editableTabs: [{
		title: '白蕉',
		name: '1',
		content:[{
			peopleCount: "",
			prizeType: "",
			discount: "",
			totalAmount: "",
			singleAmount: "",
		}],
	}, 
	{
		title: '绿蕉',
		name: '2',
		content: []
	},
	{
		title: '黄蕉',
		name: '3',
		content: []
	},
	{
		title: '金蕉',
		name: '4',
		content: []
	},
	{
		title: '黑蕉',
		name: '5',
		content: []
	},
	],
	dialogPrize: false,
  indexCoupon: 0,
}
},
computed: {},
created() {

},
mounted() {
	this.getRuleInfo()
},
methods: {
	getList(){
		this.loading = true
		getBenefitConfig().then((res) => {
			this.loading=false
			if (res.code == 1) {
				this.formData = res.data
				if(res.data.ruleDetail){
					this.fileList = [
						{
							url: res.data.ruleDetail,
							name: "活动规则说明",
						}
					]
				}else{
					this.fileList = []
				}
				if(res.data.benefitDescriptionConfigList){
					this.benefitDescriptionConfigList = []
					this.fileList2 = []
					this.benefitDescriptionConfigList  = res.data.benefitDescriptionConfigList.map((item) => {
						return { ...item, imgLoading: false,ishaveUrl:false, };
					});

				}

				
				// 暂存小程序转二维码 --start
				// let options = {
				// 	activityId: formData.id,
				// 	venderId: this.venderId,
				// 	activityType: formData.activityType || formData.type,
				// 	id: formData.id,
				// };
				let xcxUrl = this.$commonUrl(); // 正式
				// let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%7D`;
				let params1 = `venderId%3D${ res.data.venderId}`;
				this.formData.idUrl = xcxUrl + "pages/bananain/birthday/birthday.html%3f" + params1;
				//--end

				if(this.editableTabs.length == 5){
					this.editableTabs[0].content = res.data.level1BenefitConfigList
					this.editableTabs[1].content = res.data.level2BenefitConfigList
					this.editableTabs[2].content = res.data.level3BenefitConfigList
					this.editableTabs[3].content = res.data.level4BenefitConfigList
					this.editableTabs[4].content = res.data.level5BenefitConfigList
				}

				console.log("this.editableTabs",this.editableTabs)


			}else{
				this.$message.error(res.message);
			}
		});
	},
	 //获取详情
	 getRuleInfo(){
			this.loading = true,
			this.editableTabs = []
			getRuleInfo().then((res) => {
				this.loading = false;
				if (res.code == 1) {
					res.data.forEach((item,index)=>{
						this.editableTabs.push({
							title: item.name,
							name: index+1+'',
							content:[],
						})
					})
					this.getList()
				}else{
					this.$message.error(res.message);
				}
			});
		},
	//保存
	save(){
		if(!this.formData.activityCloseDescription){
			this.$message.warning("活动关闭说明文案不可为空");
			return;
		}
		if(!this.formData.ruleDetail){
			this.$message.warning("活动规则说明不可为空");
			return;
		}

		//生日权益说明图
		let isFlay = false;
		this.benefitDescriptionConfigList.forEach((item) => {
			if(item.category != 0){
				if (!item.birthdayBenefitDescription || !item.startEnableTime ||  !item.endEnableTime ) {
					isFlay = true;
				}
				}
		});
		if (isFlay) {
			return this.$message.warning("请将生日权益说明图填写完整！");
		}

		//请将等级生日权益！
		let isOk = false;
		this.editableTabs.map((item,index) => {
			item.content.forEach((item,index) => {
				console.log("item",item)
				if (!item.totalAmount || !item.startEnableTime || !item.endEnableTime) {
					isOk = true;
				}
				item.levelConfigSort = Number(index+1)
			});
		})
		if (isOk) {
			return this.$message.warning("请将等级生日权益填写完整！");
		}

		let params = {
			...this.formData ,
			benefitDescriptionConfigList:this.benefitDescriptionConfigList,
			level1BenefitConfigList:this.editableTabs[0].content,
			level2BenefitConfigList:this.editableTabs[1].content,
			level3BenefitConfigList:this.editableTabs[2].content,
			level4BenefitConfigList:this.editableTabs[3].content,
			level5BenefitConfigList:this.editableTabs[4].content,
		}

		postBenefitConfig(params).then((res) => {
			if (res.code == 1) {
				this.$message.success("操作成功！");
				this.getList()
			}else{
				this.$message.error(res.message);
			}
		})

	},
	handleSrcImg(id) {
		// 获取要下载的图片
		let img = document.querySelector(`#qrcode${id} img`);
		// 获取图片地址
		let url = img.src;
		// 创建一个a节点插入的document
		let a = document.createElement("a");
		// 模拟鼠标click点击事件
		let event = new MouseEvent("click");
		// 设置a节点的download属性值
		a.download = "huodongyulan";
		// 将图片的src赋值给a节点的href
		a.href = url;
		// 触发鼠标点击事件
		a.dispatchEvent(event);
	},
	onCopy() {
		this.$message.success("复制成功");
	},
	onError() {
		this.$message.error("复制失败");
	},
	//上传图片
	handleChange(file, fileList,item) {

		const isLt3M = file.size < 1024 * 300;
		if (!isLt3M) {
			this.$message.error("文件大小不符合要求，请重新上传");
			this.$refs.upload.clearFiles();
			
			return
		} else {
			this.fileList = fileList;
			this.$refs.upload.$children[1].$el.style.display = "none";
			// this.objectForm.name = file.name;
			let formdata = new FormData();
			formdata.append("file", file.raw);
			uploadpic(formdata,2).then((res) => {
				if(res.code == 1){
						// 获取图片真实url
						this.formData.ruleDetail = res.data.fileUrl;
				}else{
					this.$message.error(res.message);
					this.formData.ruleDetail = "";
					this.fileList = []
					this.$refs.upload.$children[1].$el.style.display = "inline-block";
				}
			});
			
		}
	},
	handleRemove(file, fileList,item) {
		// this.fileList = [];
		// this.$refs.upload.clearFiles();
		this.formData.ruleDetail = "";
		this.$refs.upload.$children[1].$el.style.display = "inline-block";
	}, 
	handleChange2(file, fileList,index) {
	const isLt3M = file.size < 1024 * 300;
	if (!isLt3M) {
		this.$message.error("文件大小不符合要求，请重新上传");
		this.benefitDescriptionConfigList[index].birthdayBenefitDescription = '';
		this.benefitDescriptionConfigList[index].ishaveUrl = false;
		this.fileList2 = []
		this.$refs.upload2.uploadFiles = [];
		this.$refs.upload2.clearFiles();
	} else {
			if(!this.benefitDescriptionConfigList[index].imgLoading){
				console.log("fileList",fileList)
				let formdata = new FormData();
				formdata.append("file", file.raw);
				this.benefitDescriptionConfigList[index].imgLoading= true;
				if(this.benefitDescriptionConfigList[index].birthdayBenefitDescription){
					this.benefitDescriptionConfigList[index].birthdayBenefitDescription=''
					this.benefitDescriptionConfigList[index].ishaveUrl = false;
				}
				uploadpic(formdata,2).then((res) => {
							this.benefitDescriptionConfigList[index].imgLoading= false;
						if(res.code == 1){
							// 获取图片真实url
							this.benefitDescriptionConfigList[index].birthdayBenefitDescription =res.data.fileUrl;
							this.benefitDescriptionConfigList[index].ishaveUrl = true;
							// this.$forceUpdate()
						}else{
							this.$message.error(res.message);
							this.benefitDescriptionConfigList[index].birthdayBenefitDescription = '';
							this.benefitDescriptionConfigList[index].ishaveUrl = false;
							this.fileList2 = []
							this.$refs.upload2.uploadFiles = [];
							this.$refs.upload2.clearFiles();
						}
				});
			}
		}
	},
	handleRemove2(file, fileList,index) {
		this.benefitDescriptionConfigList[index].birthdayBenefitDescription = '';
		this.benefitDescriptionConfigList[index].ishaveUrl = false;
		this.$forceUpdate()
	}, 
	beforeUpload(file) {
		let fileType
		if (this.limitType) {
			const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
			const type = file.name.substring(file.name.lastIndexOf("."));
			const isImage = typeArry.indexOf(type) > -1;
			if (!isImage) {
				fileType = false;
				this.$message({
					message: "图片格式不符合要求，请重新上传！",
					type: "warning",
				});
			}
		} else {
			fileType = true;
		}
		return fileType;
	},
	httpRequest() {},
	handlePictureCardPreview(file) {
		this.dialogImageUrl = file.url;
		this.dialogVisible = true;
	},
	// 增加权益图
	addBenefit() {
		this.benefitDescriptionConfigList.push({
			birthdayBenefitDescription:'',
			startEnableTime:'',
			endEnableTime:'',
			imgLoading:false,
			ishaveUrl:false,
			category:1
		});
	},
	// 删除权益
	itemDel(index) {
		if (this.benefitDescriptionConfigList.length == 1) {
			this.$message.warning("必须有一个生日权益说明图");
			return;
		}
		this.benefitDescriptionConfigList.splice(index, 1);
	},
	//活动时间驱动
	activityTimeChange(index) {
	let nowTime = new Date().getTime();
	let start = new Date(this.benefitDescriptionConfigList[index].startEnableTime).valueOf();
	let end = new Date(this.benefitDescriptionConfigList[index].endEnableTime).valueOf();
	if(index > 0){
		console.log("index",index)
		let beforeStart = new Date(this.benefitDescriptionConfigList[index-1].startEnableTime).valueOf();
		let beforeEnd = new Date(this.benefitDescriptionConfigList[index-1].endEnableTime).valueOf();
		console.log("start",start , beforeStart,  beforeEnd)
		console.log("index",start >= beforeStart&&start <= beforeEnd)
		if ( (start >= beforeStart && start <= beforeEnd) && start) {
			this.$message.warning("配置时间段含重合部分，请调整");
			this.benefitDescriptionConfigList[index].startEnableTime = ''
			return;
		}
		if ( (end >= beforeStart && end <= beforeEnd) && end) {
			this.$message.warning("配置时间段含重合部分，请调整");
			this.benefitDescriptionConfigList[index].endEnableTime = ''
			return;
		}

	}
	if (end < start && start && end) {
		this.$message.warning("结束时间不能小于开始时间");
		this.benefitDescriptionConfigList[index].endEnableTime = ''
		return;
	}
	},
	clearTime(index) {
		this.benefitDescriptionConfigList[index].startEnableTime = "";
		this.benefitDescriptionConfigList[index].endEnableTime = "";
	},

	activityTimeChange2(index) {
	let nowTime = new Date().getTime();
	let start =''
	let end =''
	this.editableTabs.forEach(item=>{
		if(item.name == this.editableTabsValue){
			 start = new Date(item.content[index].startEnableTime).valueOf();
			 end = new Date(	item.content[index].endEnableTime).valueOf();
		}
	});

	// if (end < nowTime && end) {
	// 	this.$message.warning("结束时间不能小于当前时间");
	// 	return;
	// }
	if (end < start && start && end) {
		this.$message.warning("结束时间不能小于开始时间");
		this.editableTabs.forEach(item=>{
			if(item.name == this.editableTabsValue){
				item.content[index].endEnableTime = "";
			}
		});
		return;
	}
	},
	clearTime2(index) {
		this.editableTabs.forEach(item=>{
			if(item.name == this.editableTabsValue){
				item.content[index].startEnableTime = "";
				item.content[index].endEnableTime = "";
			}
		});
	},


	//增加奖品
	addPrizeRule() {
		this.editableTabs.forEach(item=>{
			if(item.name == this.editableTabsValue){
				item.content.push({
					peopleCount: "",
					prizeType: "",
					value: "",
					totalAmount: "",
				});
			}
		})

	},
	//删除奖品
	itemDelPrize(index) {
		this.editableTabs.forEach(item=>{
			if(item.name == this.editableTabsValue){
				// if (item.content.length == 1) {
				// 	this.$message.warning("必须有一个奖项");
				// 	return;
				// }
				item.content.splice(index, 1);
			}
		})
  },
	// 选择优惠券
	selectCoupon(index) {
		this.dialogPrize = true;
		this.indexCoupon = index;
	},
	//奖品确定
	closePrize(val, params) {
      console.log(params);
      if (val) {
				this.editableTabs.forEach(item=>{
					if(item.name == this.editableTabsValue){
						// item.content[this.indexCoupon].id = params.id;
						item.content[this.indexCoupon].prizeType = params.prizeType || 1;
						item.content[this.indexCoupon].title = params.name;
						item.content[this.indexCoupon].couponType = params.couponType;

						item.content[this.indexCoupon].price =
						params.discount || params.singleAmount;
						item.content[this.indexCoupon].singleAmount = params.numPerSending;
						item.content[this.indexCoupon].assetsId = Number(params.couponId);

						console.log("item",item)
					}
				})
      }

      this.dialogPrize = false;
	},

}
}
</script>
<style lang='scss' scoped>
/deep/.hide_box .el-upload--picture-card{
    display: none;
}
/deep/.el-textarea .el-input__count{
	right: 30px;
}
.link{
	width: 100%;
	/** word-break: normal(使用浏览器默认的换行规则)|break-all(允许在西文单词中换行)|keep-all(只能在半角空格或连字符处换行);通过该属性规定自动换行的处理方法，即遵循何种方式换行。 */
	word-break: break-all; 
	/** word-wrap: normal(只在允许默认的断字点处换行，浏览器默认)|break-word(在长单词或URL内部换行);通过该属性允许长单词或URL换行到下一行。 */
	word-wrap: break-word;
	line-height:24px;
	display: flex;
	align-content: flex-start;
}
.add_btn1 {
	cursor: pointer;
	color: #7b61ff;
	border: 1px solid #7b61ff;
	width: 90px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(123, 97, 255, 0.1);
	border-radius: 4px;
	margin-top: 8px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #7b61ff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 146px;
	height: 146px;
	line-height: 146px;
	text-align: center;
}
.avatar {
	width: 146px;
	height: 146px;
	display: block;
}

.newCard{
  margin: 20px 0 0 0;
  /deep/.el-tabs__header{
    margin:0
  }
  /deep/.el-tabs__content{
  border: 1px solid #d3dce6;
    border-top: 0;
  }
  /deep/.el-tabs__new-tab{
    color:#7B61FF;
    border:1px solid #7B61FF;
    width: 25px;
    height:25px;
    margin: 8px 0 0 0;
    line-height: 25px;
    font-size: 18px;
  }
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
}
.saveBtn{
    border-radius: 4px;
    width: 72px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color:#fff;
    background: #7B61FF;
    &:hover{
      opacity: 0.9;
    }
  }
</style>